<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="4" lg="4" xl="4">
        <CCard>
          <CCardHeader>
            <i class="fa fa-filter"></i>&nbsp; Filtrar por
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="12" md="12" lg="12">
                <cSelectForm
                  label="Seleccione una Sede"
                  :options="campus"
                  placeholder="Escoja una Sede"
                  :value.sync="filter.campu"
                  @change="mtdLoadData"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol md="8" lg="12" xl="12" xxl="8" xs="8" sm="8">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de pisos"
          icon="fas fa-layer-group"
          btn_name="Piso"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
        />
      </CCol>
    </CRow>
    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <!-- <CCol sm="12">
          <cSelectForm label="Empresa" placeholder="Seleccione empresa" :options="data_companies"
            :value.sync="floor.company_id" @change="viewCampus"  :disabled="this.$store.getters.get_all_user.id !== 1" />
        </CCol> -->
        <CCol sm="12">
          <cSelectForm
            label="Sede"
            placeholder="Seleccione sede"
            :options="data_campus"
            :value.sync="floor.campu_id"
          />
        </CCol>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="floor.name"
          />
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="floor.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Rol'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  // { key: "Empresa", _style: "width:5%" },
  { key: "Sede", _style: "width:5%" },
  { key: "Nombre", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../../components/shared/datatable/Table.vue";
import CModalForm from "../../../components/shared/modals/cModalForm.vue";
import cModalDelete from "../../../components/shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import CSwitchVue from "../../shared/switch/CSwitch.vue";
import cSelectForm from "../../../components/shared/inputs/cSelect.vue";

export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    CSwitchVue,
    cSelectForm,
  },
  data() {
    return {
      prefix: "floors",
      fields,
      data: [],
      allData: [],
      campus: [],
      filter: {
        campu: 0,
      },
      data_companies: [],
      data_campus: [],
      companies_all: [],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      floor: {
        id: "",
        name: "",
        user_id: this.$store.getters.get__user_id,
        company_id: 1,
        campu_id: "",
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      dataStore: [],
    };
  },
  computed: {
    cpStatus: function () {
      if (this.floor.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (this.floor.name != "") return false;
      return true;
    },
  },
  created() {
    this.mtd_getdata();
    this.indexCampus();
  },
  methods: {
    ...mapActions(["get", "post"]),
    indexCampus: function () {
      this.get({
        url: this.$store.getters.get__url + "/campus/company",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          // console.log(response);
          response.data.forEach((element) => {
            this.data_companies.push({
              label: element.name,
              value: element.id,
            });
          });
          //almacenar las empresa
          this.companies_all = response.data;
          this.viewCampus();          
        })
        .catch((errors) => {});
    },
    viewCampus: function () {
      //filtrar para ver de acuerdo al id de company
      const selectedCompany = this.companies_all.find(
        (company) => company.id === 1
      );
      this.data_campus = [];
      if (selectedCompany && selectedCompany.campu) {
        this.data_campus = selectedCompany.campu
          .filter((campu) => campu.state === 1)
          .map((campu) => ({
            label: campu.name,
            value: campu.id,
          }));
      }
      this.floor.campu_id = "";
      this.campus = [
            { value: 0, label: "TODAS LAS SEDES" },
            ...this.data_campus.map((item) => ({
              label: item.label,
              value: item.value,
            })),
          ];
    },
    mtd_getdata: function () {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index/" +
          this.$store.getters.get__user_id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.allData = response.data.data;
          let index = 1;
          this.allData.forEach((arr) => {
            arr.index = index;
            index++;
          });
          this.data = this.allData;
          this.dataStore = response.data.all;
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdLoadData: function () {
      const campu = this.filter.campu;
      if (campu == 0) {
        this.data = this.allData;
      } else {
        this.data = this.allData.filter((item) => item.campu_id == campu);
      }
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Piso")
        : (this.modal.title = "Editar Piso");
      action == "store"
        ? (this.floor = {
            id: "",
            name: "",
            user_id: this.$store.getters.get__user_id,
            company_id:
              this.$store.getters.get_all_user.id == 1
                ? ""
                : this.$store.getters.get_company.id,
            campu_id: "",
            state: "",
          })
        : (this.floor = this.floor);
      if (this.modal.action != "store") {
        this.componentKey += 1;
      } else {
        // this.data_campus = []
      }
    },
    mtd_action: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.floor,
      })
        .then((response) => {
          let color = "success";
          let message = "";
          if (response.data.state == 1) {
            Swal.fire({
              title: "Piso ya resgistrado",
              icon: "info",
            });
          } else {
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
            } else {
              message = "EDITADO CORRECTAMENTE";
            }
            this.mtd_getdata();
            Swal.fire({
              title: message,
              icon: color,
            });
          }
          this.modal = {
            action: "",
            title: "",
            modal_form: false,
            name: "",
          };
          this.floor = {
            id: "",
            name: "",
            user_id: this.$store.getters.get__user_id,
            company_id:
              this.$store.getters.get_all_user.id == 1
                ? ""
                : this.$store.getters.get_company.id,
            campu_id: "",
            state: 0,
          };
          this.dataStore = response.all;
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.floor.company_id = response.company_id;
          this.viewCampus();
          this.floor = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };
          this.dataStore = response.all;
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => {});
    },
    changeSwitch: function (payload) {
      this.floor.state = payload == true ? 1 : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>
